import React from 'react';
import { Alert } from 'antd';
import { formatDate } from '../../../../shared/packages/dateTime';

const IndividualDatesAlert = ({ startDate, endDate }) => {
  if (!startDate && !endDate) {
    return null;
  }

  let message;

  if (startDate && endDate) {
    const formatedStart = formatDate(startDate);
    const formatedEnd = formatDate(endDate);
    message = `Доступные интервалы для записи - в период с ${formatedStart} до ${formatedEnd}`;
  } else if (startDate && !endDate) {
    const formattedDate = formatDate(startDate);
    message = `Доступные интервалы для записи - начиная с ${formattedDate}`;
  } else {
    const formattedDate = formatDate(endDate);
    message = `Доступные интервалы для записи - не позднее ${formattedDate}`;
  }

  return <Alert type="info" message={message} />;
};

export default IndividualDatesAlert;
